"use strict";
/**
 * 获取所有 cookie
 *
 * ### Example
 * ```
 * const cookies = getAllCookie();
 * const { uuid, token, userid } = cookies;
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
var decode_1 = require("./decode");
function getAllCookie() {
    var cookies = document.cookie.split('; ');
    var result = {};
    for (var i = 0, l = cookies.length; i < l; i++) {
        var item = cookies[i].split('=');
        var key = item.shift();
        result[key] = decode_1.decode(item.join('='));
    }
    return result;
}
exports.getAllCookie = getAllCookie;
